import { getDatabase } from "firebase/database";

const db = getDatabase();

export {db};